// src/utils/media.js
import { getAssetUrl } from "../config";

export const getMediaUrls = (photo) => {
  const mediaType = String(photo?.media_type || "PHOTO").toUpperCase();
  const isVideo = mediaType === "VIDEO";

  const rawThumb = photo?.thumbnail_path || null;
  const rawFile = photo?.file_path || null;

  // Photos:
  const imageUrl = !isVideo ? getAssetUrl(rawThumb || rawFile) : null;

  // Videos:
  const videoUrl = isVideo ? getAssetUrl(rawFile) : null;
  const posterUrl = isVideo ? getAssetUrl(rawThumb) : null;

  // Lightbox should prefer full-quality file if available
  const lightboxUrl = getAssetUrl(rawFile || rawThumb);

  return { isVideo, imageUrl, videoUrl, posterUrl, lightboxUrl };
};